// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__VtIPM","modal":"Modal_modal__OsPQP","header":"Modal_header__jB7T8","body":"Modal_body__Hueb+","footer":"Modal_footer__CU0z7","close":"Modal_close__IxIVD"};